module.exports = __webpack_public_path__ + "static/img/zycp_guanlixing_a.8e96a42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/zycp_guanlixing_a.jpg
// module id = R0Uy
// module chunks = 1